import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Breadcrumbs,
  Button,
  Content,
  Loading,
} from '@orobix/orobix-fe-components'
import { useContext, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

import useDriverStyle from '../../components/Driver/driver.styles'
import PageHeader from '../../components/PageHeader/PageHeader'
import { SettingsContext } from '../../components/Settings'
import useUpdateSettings from '../../components/Settings/useUpdateSettings'
import { useDispatch, useStore } from '../../store/store'
import { fetchProduct, fetchProject } from '../../store/storeActions'
import { vars } from '../../utils/appConfig'
import { locations } from '../../utils/locations'
import DatasetImageTraining from '../TrainingNew/DatasetImageTraining'
import TrainingsAside from '../Trainings/TrainingsAside'
import getDriver from './Driver'
import useStyles from './ImagesRoot.styles'

interface RouteParams {
  productId: string
  projectId: string
}

const ImagesRoot = () => {
  const { t } = useTranslation()
  const { product, project } = useStore()
  const dispatch = useDispatch()
  const { productId, projectId } = useParams<RouteParams>()
  const classes = useStyles()
  const guidedTourShown = useRef(false)

  useEffect(() => {
    if (!project) {
      fetchProject(dispatch, Number(projectId))
    }
  }, [dispatch, project, projectId])

  useEffect(() => {
    if (!product) {
      fetchProduct(dispatch, Number(productId))
    }
  }, [dispatch, product, productId])

  const classesDriver = useDriverStyle()
  const { settings } = useContext(SettingsContext)
  const { updateSettings } = useUpdateSettings()

  const updatePreference = () => {
    const checkbox = document.getElementById(
      'doNotShowAgainCheckbox'
    ) as HTMLInputElement
    if (checkbox.checked === settings.preference__show_guided_tour) {
      updateSettings({
        preference__show_guided_tour: !checkbox.checked,
      })
    }
  }

  const driverObj = getDriver(
    classesDriver,
    settings,
    updateSettings,
    updatePreference,
    product ? product.type : 'classification'
  )

  useEffect(() => {
    if (guidedTourShown.current === false) {
      if (settings.preference__show_guided_tour && !driverObj.isActive()) {
        driverObj.drive()
        guidedTourShown.current = true
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings.preference__show_guided_tour])

  return product && project ? (
    <Content
      aside={<TrainingsAside />}
      asideWidth={vars.asideWidth}
      childrenClassName={classes.content}
      breadcrumbs={
        <Breadcrumbs
          elements={[
            <Link to={locations.projects}>{t('Projects')}</Link>,
            <Link to={locations.products(Number(projectId))}>
              {project.name}
            </Link>,
            <Link
              to={locations.trainings(Number(projectId), Number(productId))}
            >
              {product.name}
            </Link>,
            t('Images'),
          ]}
        />
      }
    >
      <PageHeader
        title={t('Images')}
        right={
          <Button
            label={t('Explain me how')}
            hideLabel
            icon={<FontAwesomeIcon icon={faCircleQuestion} size="lg" />}
            type="blank-default"
            onClick={() => {
              driverObj.drive()
            }}
          />
        }
      />
      <DatasetImageTraining />
    </Content>
  ) : (
    <Content>
      <Loading />
    </Content>
  )
}

export default ImagesRoot
